import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

// @desc Photo Animation
export const PhotoAnimation = ({ children }) => {
  const photoref = useRef(null);
  const isInView = useInView(photoref, { triggerOnce: true });

  const mainControls = useAnimation();

  const animationVariant = {
    hidden: {
      opacity: 0,
      y: '100%',
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.4,
      },
    },
  };

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView, mainControls]);

  return (
    <div ref={photoref} style={{ position: 'relative', overflow: 'hidden' }}>
      <motion.div
        variants={animationVariant}
        initial='hidden'
        animate={mainControls}
        style={{ position: 'relative' }}
      >
        {children}
      </motion.div>
    </div>
  );
};
